/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachmentV1Dto } from './AttachmentV1Dto';
import type { EmailTicketV1Dto } from './EmailTicketV1Dto';
export type EmailV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Indicates if the email is automatically assigned to a ticket.
   */
  autoAssigned?: boolean;
  /**
   * The arrival date of the email.
   */
  receiptDate: string;
  /**
   * Subject of the email.
   */
  readonly subject: string;
  /**
   * Sender of the email.
   */
  readonly senderEmail: string;
  /**
   * Display name of the sender
   */
  readonly senderName?: string;
  /**
   * CC recipients as email addresses.
   */
  ccRecipients?: Array<string>;
  /**
   * TO recipients as email addresses.
   */
  toRecipients?: Array<string>;
  /**
   * Body of the email.
   */
  readonly content: string;
  /**
   * The type of the content of the email.
   */
  readonly contentType: EmailV1Dto.contentType;
  /**
   * set the NotApplicable flag for classification
   */
  isClassificationNotApplicable: boolean;
  /**
   * Attachments correlating to the email.
   */
  attachments: Array<AttachmentV1Dto>;
  /**
   * The Tickets the email is related to.
   */
  readonly tickets: Array<EmailTicketV1Dto>;
  /**
   * true if the email and attachment link to at least one ticket, false otherwise
   */
  readonly isClassified: boolean;
};
export namespace EmailV1Dto {
  /**
   * The type of the content of the email.
   */
  export enum contentType {
    HTML = 'Html',
    PLAIN_TEXT = 'PlainText',
  }
}
